import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FiEdit2, FiPlus, FiShoppingBag, FiTrash2 } from 'react-icons/fi';
import { AppLayout } from '../../components/AppLayout';
import { Button } from '../../components/Button';
import { Table } from '../../components/Table';
import { AcaoIcone } from '../../components/AcaoIcone';
import { listarProdutos, removerProduto } from '../../api/produtos';
import { Produto } from '../../types';
import { formatarMoeda } from '../../utils/formatadores';

export function ProdutosLista() {
  const [produtos, setProdutos] = useState<Produto[]>([]);
  const [carregando, setCarregando] = useState(true);

  function carregar() {
    setCarregando(true);
    listarProdutos()
      .then(setProdutos)
      .finally(() => setCarregando(false));
  }

  useEffect(carregar, []);

  async function handleRemover(produto: Produto) {
    const confirmacao = await Swal.fire({
      icon: 'warning',
      title: `Remover "${produto.nome}"?`,
      showCancelButton: true,
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar',
    });

    if (!confirmacao.isConfirmed) {
      return;
    }

    await removerProduto(produto.id);
    carregar();
  }

  return (
    <AppLayout>
      <div className="lizzi-cabecalho-pagina">
        <h1>
          <span className="lizzi-icone-titulo">
            <FiShoppingBag size={18} />
          </span>
          Produtos
        </h1>
        <Link to="/produtos/novo">
          <Button fullWidth={false}>
            <FiPlus size={16} style={{ marginRight: '6px', verticalAlign: '-2px' }} />
            Novo produto
          </Button>
        </Link>
      </div>

      {carregando ? (
        <p>Carregando...</p>
      ) : (
        <Table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Categoria</th>
              <th>Preço de venda</th>
              <th>CMV</th>
              <th>Margem</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {produtos.map((produto) => (
              <tr key={produto.id}>
                <td>{produto.nome}</td>
                <td>{produto.categoria_nome || '-'}</td>
                <td>{formatarMoeda(produto.preco_venda)}</td>
                <td>{formatarMoeda(produto.cmv)}</td>
                <td>
                  {formatarMoeda(produto.margem_lucro)}
                  {produto.margem_percentual !== null && ` (${produto.margem_percentual}%)`}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <Link to={`/produtos/${produto.id}/editar`}>
                      <AcaoIcone icon={<FiEdit2 size={15} />} aria-label="Editar" />
                    </Link>
                    <AcaoIcone icon={<FiTrash2 size={15} />} tone="perigo" onClick={() => handleRemover(produto)} aria-label="Remover" />
                  </div>
                </td>
              </tr>
            ))}
            {produtos.length === 0 && (
              <tr>
                <td colSpan={6} style={{ padding: '16px', textAlign: 'center' }}>
                  Nenhum produto cadastrado ainda.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </AppLayout>
  );
}
